// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Lane/Lane.css */
.lane {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%; /* Take full height of parent */
  padding: 10px;
  box-sizing: border-box;
  position: relative;
  background-color: #ECF0F1;
  border-radius: 10px;
  border: 1px solid #BDC3C7;
  margin-bottom: 10px;
}

.remove-lane {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #E74C3C;
  color: #ECF0F1;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 2;
  padding: 5px;
}

.lane-info {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%) rotate(180deg);
  white-space: nowrap;
  font-weight: bold;
  font-size: 14px;
  color: #2C3E50;
}

.boxes-container {
  display: flex;
  flex-grow: 1;
  justify-content: center; /* Center the boxes */
  align-items: center;
  overflow-x: auto;
  padding-left: 40px; /* Make space for lane-info */
  padding-right: 40px; /* Balance the padding */
  height: 100%;
}

.box {
  flex-shrink: 0;
  width: 200px;
  height: 80%;
  margin: 0 10px; /* Add margin to both sides */
  background-color: white;
  border-radius: 10px;
  border: 1px solid #BDC3C7;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}


.box-placeholder {
  border: 1px dashed #BDC3C7;
}

.box-header {
  width: 100%;
  height: 20px;
  background-color: var(--box-header-color, #FF6F61);
  position: absolute;
  top: 0;
  left: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  z-index: 1;
}

.box-header.box2 {
  background-color: var(--box-header-color, #FFD700);
}

.box-content {
  padding: 10px;
  margin-top: 20px;
}

.remove-box {
  position: absolute;
  top: 22px;
  right: 5px;
  background: none;
  border: none;
  color: #E53935;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Lane/Lane.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAE,+BAA+B;EAC7C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB,EAAE,qBAAqB;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAE,6BAA6B;EACjD,mBAAmB,EAAE,wBAAwB;EAC7C,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,cAAc,EAAE,6BAA6B;EAC7C,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ","sourcesContent":["/* src/components/Lane/Lane.css */\n.lane {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  height: 100%; /* Take full height of parent */\n  padding: 10px;\n  box-sizing: border-box;\n  position: relative;\n  background-color: #ECF0F1;\n  border-radius: 10px;\n  border: 1px solid #BDC3C7;\n  margin-bottom: 10px;\n}\n\n.remove-lane {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background-color: #E74C3C;\n  color: #ECF0F1;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 2;\n  padding: 5px;\n}\n\n.lane-info {\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%) rotate(180deg);\n  white-space: nowrap;\n  font-weight: bold;\n  font-size: 14px;\n  color: #2C3E50;\n}\n\n.boxes-container {\n  display: flex;\n  flex-grow: 1;\n  justify-content: center; /* Center the boxes */\n  align-items: center;\n  overflow-x: auto;\n  padding-left: 40px; /* Make space for lane-info */\n  padding-right: 40px; /* Balance the padding */\n  height: 100%;\n}\n\n.box {\n  flex-shrink: 0;\n  width: 200px;\n  height: 80%;\n  margin: 0 10px; /* Add margin to both sides */\n  background-color: white;\n  border-radius: 10px;\n  border: 1px solid #BDC3C7;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n\n.box-placeholder {\n  border: 1px dashed #BDC3C7;\n}\n\n.box-header {\n  width: 100%;\n  height: 20px;\n  background-color: var(--box-header-color, #FF6F61);\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  z-index: 1;\n}\n\n.box-header.box2 {\n  background-color: var(--box-header-color, #FFD700);\n}\n\n.box-content {\n  padding: 10px;\n  margin-top: 20px;\n}\n\n.remove-box {\n  position: absolute;\n  top: 22px;\n  right: 5px;\n  background: none;\n  border: none;\n  color: #E53935;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
